
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|1878|5422|9328)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
